import { getAppEnvironmentAtRuntime } from '@/lib/env/services/env.helpers'

/**
 * Retrieves build-time HTTP headers for Apollo client requests.
 */
export const getBuildTimeHeaders = () => ({
  'x-commit-version': process.env.NEXT_PUBLIC_COMMIT_VERSION || 'version',
  'x-commit-hash': process.env.NEXT_PUBLIC_COMMIT_HASH || 'hash',
  'x-distribution-network': process.env.NEXT_PUBLIC_BRAND || 'NONE',
})

export type RuntimeVariables = {
  apolloClientDevtoolEnabled: boolean
  graphqlApiUrl?: string
  appEnvironment: string
}

/**
 * Retrieves runtime variables for Apollo client configuration.
 */
export const getApolloRuntimeVariables = (): RuntimeVariables => ({
  apolloClientDevtoolEnabled:
    (process.env.NEXT_PUBLIC_APOLLO_CLIENT_DEVTOOL_ENABLED || 'false') === 'true',
  graphqlApiUrl: process.env.NEXT_PUBLIC_DC_URL_API_CLIENT,
  appEnvironment: getAppEnvironmentAtRuntime(),
})
